import { Component } from '@angular/core';
import { IconComponent } from '@standalone/components/icon/icon.component';
import { FeedbackPopupComponent } from '@standalone/components/feedback-popup/feedback-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-feedback-button',
  standalone: true,
  imports: [IconComponent, TranslocoPipe],
  templateUrl: './feedback-button.component.html',
  styleUrl: './feedback-button.component.scss',
})
export class FeedbackButtonComponent {
  constructor(public dialog: MatDialog) {}

  public openFeedbackModal(): void {
    this.dialog.open(FeedbackPopupComponent, {
      width: '500px',
    });
  }
}
